import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesPrioritiesDeleteRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-priorities-delete',
	path: '/secure/admin/DeletePriority!default.jspa',
};
